import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-af8ffc7e")

_pushScopeId("data-v-af8ffc7e")
const _hoisted_1 = { class: "tooltip-cont" }
const _hoisted_2 = /*#__PURE__*/_createVNode("span", { class: "tooltip-arrow" }, null, -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_SelectItemRegion = _resolveComponent("SelectItemRegion")

  return (_openBlock(), _createBlock("div", {
    class: ["regions-map-container block w-full max-w-450", _ctx.cssClass]
  }, [
    (_openBlock(), _createBlock("svg", {
      id: "regionsMap",
      "data-cy": "list-region-svg",
      class: "regions-map",
      xmlns: "http://www.w3.org/2000/svg",
      "fill-rule": "evenodd",
      "clip-rule": "evenodd",
      viewBox: "0 0 496 491",
      onMousemove: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.mouseMove && _ctx.mouseMove(...args)))
    }, [
      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.regionsPaths, (path) => {
        return (_openBlock(), _createBlock("a", {
          key: path,
          href: _ctx.getLink(path)
        }, [
          _createVNode("path", {
            "data-region": path.dataRegion,
            fill: "#bec1ce",
            stroke: "#fff",
            class: {active: _ctx.activeRegion(path.dataRegion)},
            "stroke-width": ".9",
            d: path.d,
            onMouseover: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.hoverRegion && _ctx.hoverRegion(...args))),
            onMouseleave: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.mouseLeave && _ctx.mouseLeave(...args)))
          }, null, 42, ["data-region", "d"])
        ], 8, ["href"]))
      }), 128))
    ], 32)),
    _createVNode("div", {
      ref: "tooltipMap",
      class: "tooltip-map tooltip-map-nav",
      style: [{"transform":"translateX(-50%)"}, {
        display: _ctx.showTooltip ? 'block' : 'none',
        top: _ctx.mousePosition.top,
        left: _ctx.mousePosition.left
      }]
    }, [
      _createVNode("a", _hoisted_1, _toDisplayString(_ctx.regionTitle), 1),
      _hoisted_2
    ], 4),
    (_ctx.regionList.length > 0)
      ? (_openBlock(), _createBlock(_component_SelectItemRegion, {
          key: 0,
          class: "select-item-region-comp md:hidden",
          "map-position": _ctx.mapPosition,
          "select-data": _ctx.regionList,
          "selected-prop-region": _ctx.selectedRegion,
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.scrollTo($event)))
        }, null, 8, ["map-position", "select-data", "selected-prop-region"]))
      : _createCommentVNode("", true)
  ], 2))
})